import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: 16,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },

  cardHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16,

    '& span': {
      display: 'block'
    },

    '& span:last-child': {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.primary.main
    }
  },

  cardContent: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: 16
  },

  cardFooter: {
    display: 'flex',
    gap: 8,

    '& span': {
      display: 'block',
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.primary.main
    },

    '& svg path': {
      fill: theme.palette.primary.main
    }
  }
}))
